import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_52: FaireProductEntity = {
  token: "catalog_prod_prod-52",
  type: "product",
  name: "Stone Coasters - Set of 4",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 44.36,
  msrpDollars: 110.9,
  sku: "JA0052",
  caseSize: 3,
  material: "Cotton",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 366,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
